import SearchInput from './SearchInput'

export default SearchInput
export type { SearchInputProps } from './SearchInput'
